import type { Core } from 'chessboard/core/config/types';
import { createHighlights } from 'chessboard/plugins/highlights/service';
import type { API, HighlightsModule } from 'chessboard/plugins/highlights/config/types';

// These are the parameters that are provided to the `update` method of each of the
// highlights modules.
export type UpdateParameters = [Core.Event, Core.Context];

/**
 * Create the highlights API. This is just a wrapper around the service.
 */
export function createHighlightsAPI(initialModules: HighlightsModule<UpdateParameters>[]) {
  return function createAPI(): API<UpdateParameters> {
    return createHighlights<UpdateParameters>(initialModules);
  };
}
